/*
 * Highcharts Graph: https://www.highcharts.com/demo/highcharts
 * Supported Graphs: Bar, Pie
 */

import React, { useRef } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import SolidGauge from "highcharts/modules/solid-gauge";
import HighchartsMore from "highcharts/highcharts-more";
import Highcharts3d from "highcharts/highcharts-3d";

import { GRAPH_TYPES } from "common/config";
import { GRAPHS } from "common/graphs";
import { COLORS } from "common/colors";

HighchartsMore(Highcharts);
SolidGauge(Highcharts);
Highcharts3d(Highcharts);

interface cProps {
  width: string;
  type: "column" | "pie" | "bar" | "solidgauge" | "stakedbar";
  title: string;
  exportTitle: string;
  float?: "left" | "right";
  xAxis?: string[];
  yAxis?: number[];
  series?: any;
  colors?: string[];
  xAxisTitle?: string;
  yAxisTitle?: string;
  height?: number;
}

const HGraph = (props: any) => {
  const {
    width,
    type,
    title,
    exportTitle,
    float,
    xAxis,
    yAxis,
    series,
    colors,
    yAxisTitle,
    xAxisTitle,
    height,
  } = props;
  const chartRef: any = useRef(null);

  const getOptions = () => {
    switch (type) {
      case GRAPH_TYPES.COLUMN:
        return GRAPHS.getColumnGraph(
          title,
          xAxis,
          yAxis,
          xAxisTitle,
          yAxisTitle,
          exportTitle,
          height
        );
      case GRAPH_TYPES.PIE:
        return GRAPHS.getPieGraph(title, series, exportTitle, height);
      case GRAPH_TYPES.STACKED_BAR:
        return GRAPHS.getStackedBar(
          title,
          xAxis,
          yAxis,
          series,
          xAxisTitle,
          yAxisTitle,
          exportTitle,
          height
        );
      case GRAPH_TYPES.BAR:
        return GRAPHS.getBarGraph(
          title,
          xAxis,
          yAxis,
          xAxisTitle,
          yAxisTitle,
          exportTitle,
          height
        );
      case GRAPH_TYPES.SOLIDGAUGE:
        return GRAPHS.getSolidGauge(title, series, title, height);
      default:
        break;
    }
  };

  const options: any = getOptions();

  if (colors) {
    options.colors = colors;
  }

  console.log("options: ", options);

  return (
    <div
      className="graphBox"
      style={{
        width: width,
        flexDirection: "row",
        justifyContent: float === "right" ? "flex-end" : "flex-start",
      }}
    >
      <div style={{ width: "100%" }}>
        <HighchartsReact
          highcharts={Highcharts}
          options={options}
          ref={chartRef}
        />
      </div>
    </div>
  );
};

export default HGraph;
